import script from "./ToolTipLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolTipLabel.vue?vue&type=script&setup=true&lang=ts"

import "./ToolTipLabel.vue?vue&type=style&index=0&id=1f2f3afb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2f3afb"]])

export default __exports__